import { UserStorage } from "@/storage/UserStorage";

/**
 * Hook for handling user logout.
 * - Clears local storage authentication data
 */
export const useLogout = () => {
	const logout = () => {
		UserStorage.removeToken();
		window.location.reload();
	};

	return logout;
};
